<template>
  <div>
    <h1 class="page-header">{{ $t('leaveSubItem.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <div class="overflow-auto">
          <ts-table
            :columns="columns"
            :records="resources"
            :loading="loading"
            :rowGroup="{
              field: 'leave_type.leave_type_en'
            }"
          >
            <template v-slot="{ record, index }">
              <td class="ts-whitespace-no-wrap">{{ record.leave_sub_item }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.max_day_allow }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.max_request_per_time }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.allow_for }}</td>
              <td class="ts-whitespace-no-wrap text-center">
                <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="'Delete'"
                  class="text-danger"
                  @click.prevent="destroy(record)"
                  :disabled="record._deleting"
                >
                  <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                  <i class="fas fa-trash" v-else></i>
                </a>
              </td>
            </template>
          </ts-table>
        </div>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import FormComponent from './form'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'leaveSubItem',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('hr/leaveSubItem', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.leaveSubItem.search
      },
      set(newValue) {
        this.$store.commit('hr/leaveSubItem/SET_SEARCH', newValue)
        this.$store.commit('hr/leaveSubItem/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('leaveSubItem.pageTitle'),
          sortKey: 'leave_sub_item'
        },
        {
          name: this.$t('leaveSubItem.maxDayAllow'),
          sortKey: 'max_day_allow'
        },
        {
          name: this.$t('leaveSubItem.maxRequestPerTime'),
          sortKey: 'max_request_per_time'
        },
        {
          name: this.$t('leaveSubItem.allowFor')
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/leaveSubItem/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '22%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('hr/leaveSubItem/destroy', record.leave_sub_item_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/leaveSubItem/RESET_STATE')
    next()
  }
}
</script>
